import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Breadcrumb.css';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const Breadcrumb: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const currentLanguage = i18n.language;
  
  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    const items: BreadcrumbItem[] = [
      { label: currentLanguage === 'fr' ? 'Accueil' : 'Home', path: '/' }
    ];
    
    if (location.pathname === '/cloud-blind-spots') {
      items.push({
        label: currentLanguage === 'fr' ? 'Guide de téléchargement' : 'Download Guide',
        path: '/cloud-blind-spots'
      });
    }
    
    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();
  
  // Only the download guide has a second crumb. Other pages already have header navigation.
  if (location.pathname !== '/cloud-blind-spots') {
    return null;
  }

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {breadcrumbItems.map((item, index) => (
          <li key={item.path} className="breadcrumb-item">
            {index === breadcrumbItems.length - 1 ? (
              <span className="breadcrumb-current" aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link to={item.path} className="breadcrumb-link">
                {item.label}
              </Link>
            )}
            {index < breadcrumbItems.length - 1 && (
              <span className="breadcrumb-separator" aria-hidden="true">
                &gt;
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
